import React from 'react';
import { Moment } from 'moment';
import DateTimeRangePicker from 'components/calendar/rangePicker';
import STRING from 'utils/string';
import { cn } from 'lib/utils';

export interface DateRangeBarProps {
  dateFrom: Moment;
  dateTo: Moment;
  setDateFrom: React.Dispatch<React.SetStateAction<Moment>>;
  setDateTo: React.Dispatch<React.SetStateAction<Moment>>;
  comparisonFrom?: string;
  comparisonTo?: string;
  showDateFilter?: boolean;
  showComparison?: boolean;
  className?: string;
}

/**
 * Reusable date range bar component with date picker and comparison text.
 * Extracts the common pattern used across Dashboard, Tips, and Transactions views.
 */
const DateRangeBar: React.FC<DateRangeBarProps> = ({
  dateFrom,
  dateTo,
  setDateFrom,
  setDateTo,
  comparisonFrom,
  comparisonTo,
  showDateFilter = true,
  showComparison = true,
  className,
}) => {
  const hasComparison = showComparison && comparisonFrom && comparisonTo;

  return (
    <div className={cn('flex items-center', className)}>
      {showDateFilter && (
        <DateTimeRangePicker
          initialStartValue={dateFrom}
          initialEndValue={dateTo}
          setStartDatetime={setDateFrom}
          setEndDatetime={setDateTo}
        />
      )}
      {hasComparison && (
        <div className="text-gray-blue-50 text-sm font-normal leading-5 ml-4">
          {`compared to ${STRING.getComparisonDateString(
            comparisonFrom,
            comparisonTo
          )}`}
        </div>
      )}
    </div>
  );
};

export default DateRangeBar;
